// extracted by mini-css-extract-plugin
module.exports = {"pagination":"BlogPagination_pagination___6UKf","active":"BlogPagination_active__d5Z4L","disabled":"BlogPagination_disabled__qMzKJ"};